
import { History, Shield, Brain } from "lucide-react";
import ProcessCard from "./ProcessCard";

const StrategyEvaluation = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <ProcessCard 
        icon={<History className="w-6 h-6 text-[#1B2F47]" />} 
        title="Historical Performance & Consistency" 
        content="The track record of the strategy is closely examined, including returns, volatility, and risk-adjusted performance over various market conditions." 
      />
      <ProcessCard 
        icon={<Shield className="w-6 h-6 text-[#1B2F47]" />} 
        title="Risk Management Protocols" 
        content="Well-defined risk controls are essential for sustaining performance over the long term, including stop-loss mechanisms and drawdown controls." 
      />
      <ProcessCard 
        icon={<Brain className="w-6 h-6 text-[#1B2F47]" />} 
        title="Trading Logic & Adaptability" 
        content="The underlying methodology and adaptability of the strategy are thoroughly analyzed to ensure resilience across market conditions." 
      />
    </div>
  );
};

export default StrategyEvaluation;
